import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { LFD_COLOUR_OPTIONS } from 'utils/lfdColours';

function toKey(codes: string[]): string {
  return codes.join(',');
}

type LFDColourProps = {
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
  size?: 'small' | 'medium';
};

export default function LFDColour({ value, onChange, disabled = false, size = 'medium' }: LFDColourProps) {
  const currentKey = toKey(value);
  const matched = LFD_COLOUR_OPTIONS.find((o) => toKey(o.codes) === currentKey);
  const selectValue = matched ? currentKey : toKey(LFD_COLOUR_OPTIONS[0].codes);

  return (
    <FormControl fullWidth size={size} disabled={disabled}>
      <InputLabel>Colour</InputLabel>
      <Select
        label="Colour"
        value={selectValue}
        onChange={(e) => {
          const option = LFD_COLOUR_OPTIONS.find((o) => toKey(o.codes) === e.target.value);
          if (option) onChange(option.codes);
        }}
      >
        {LFD_COLOUR_OPTIONS.map((option) => (
          <MenuItem key={toKey(option.codes)} value={toKey(option.codes)}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
